import { useState, useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { CheckoutProvider } from "@stripe/react-stripe-js";

import { Skeleton } from "@mui/material";

import { STRIPE_API_KEY } from "@/config";
import { request } from "@/Api";
import PaymentForm from "@/payment/PaymentForm";

// Call this outside render to avoid recreating the `Stripe` object on every render
const stripePromise = loadStripe(STRIPE_API_KEY);

export default function Payment({ priceKey, confirmText, amount }) {
    const [loading, setLoading] = useState(true);
    const paymentSessionData = {
        price_key: priceKey,
        amount: amount,
    };

    const checkoutPromise = useMemo(() => {
        return request
            .post("/payments/session", paymentSessionData)
            .then((response) => {
                setLoading(false);
                return response.data;
            });
    }, []);

    return (
        <div style={{ minHeight: "476px" }}>
            {loading ? (
                <Skeleton variant="rectangular" width="100%" height={476} />
            ) : (
                <CheckoutProvider
                    stripe={stripePromise}
                    options={{
                        fetchClientSecret: () => checkoutPromise,
                        elementsOptions: {
                            appearance: { theme: "flat" },
                        },
                    }}
                >
                    <PaymentForm confirmText={confirmText} />
                </CheckoutProvider>
            )}
        </div>
    );
}
